import opentype from "opentype.js";

export const loadCustomFont = async (fontFamily, fontUrl) => {
  try {
    const font = new FontFace(fontFamily, `url('${fontUrl}')`);

    font
      .load()
      .then(() => {
        document.fonts.add(font);
      })
      .catch((err) => {
        console.error("Error loading font:", fontFamily, err);
      });
  } catch (error) {
    console.error(`Error loading custom font ${fontFamily}:`, error);
  }
};

export const readFileAsArrayBuffer = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => resolve(e.target.result);
    reader.onerror = (e) => reject(e);
    reader.readAsArrayBuffer(file);
  });
};

export const getFontInfo = (arrayBuffer, fileName) => {
  try {
    const font = opentype.parse(arrayBuffer);
    const fontName = font.names.fullName.en || fileName;
    const fontFormat = fileName.split(".").pop().toLowerCase();
    return { fontName, fontFormat };
  } catch (error) {
    console.error("Error parsing font:", error);
    return { fontName: fileName, fontFormat: "unknown" };
  }
};

export async function loadFont(fontName, fontOptions, customFonts) {
  if (!fontName) {
    console.warn("No font name provided");
    return null;
  }

  const googleFont = fontOptions.find((font) => font.fontFamily === fontName);

  if (googleFont) {
    try {
      const f = await googleFont.load();
      f?.loadFont();
      return f.getInfo().fontFamily;
    } catch (error) {
      console.error("Error loading Google Font:", error);
      return null;
    }
  } else {
    try {
      const searchedFont = getCustomFont(fontName, customFonts);

      if (!searchedFont) {
        console.error("Custom font not found:", fontName);
        return null;
      }
      await loadCustomFont(searchedFont.fontFamily, searchedFont.fontUrl);
      return fontName;
    } catch (error) {
      console.error("Error loading custom font:", error);
      return null;
    }
  }
}

export const getCustomFont = (fontName, customFonts) => {
  const matchingFonts = customFonts.filter(
    (font) => font.fontFamily === fontName
  );

  if (matchingFonts.length === 0) {
    return null;
  }

  if (matchingFonts.length === 1) {
    return matchingFonts[0];
  }

  const latestFont = matchingFonts.sort((a, b) => {
    const dateA = new Date(a.created_at);
    const dateB = new Date(b.created_at);
    return dateB - dateA;
  })[0];

  return latestFont;
};

export const getFontFormat = (fontUrl) => {
  if (fontUrl.endsWith(".woff2")) return "woff2";
  if (fontUrl.endsWith(".woff")) return "woff";
  if (fontUrl.endsWith(".ttf")) return "truetype";
  if (fontUrl.endsWith(".otf")) return "opentype";
  return "unknown";
};
